import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators} from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from './../../services';
import { environment } from './../../../environments/environment';
import { AuthenticationDetails, CognitoUser, CognitoUserPool } from 'amazon-cognito-identity-js';
import { config, CognitoIdentityCredentials, CognitoIdentityServiceProvider } from 'aws-sdk'
import { DialogService } from '../../services/dialog/dialog.service';
import { ChangePasswordChallengeComponent } from '../change-password-challenge/change-password-challenge.component';
import { COGNITO_ERROR_NOT_AUTHORIZED_EXCEPTION, COGNITO_ERROR_PASSWORDRESET_REQUIRED_EXCEPTION, COGNITO_ERROR_USER_NOT_CONFIRMED_EXCEPTION, COGNITO_ERROR_USER_NOT_FOUND_EXCEPTION } from '../../utils/constant';
import { LanguageService } from 'src/app/services/language/language.service';
import * as _ from 'lodash';
import { PATTERN_EMAIL } from 'src/app/utils/constant'

@Component({
  selector: 'esc-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {

  forgotPasswordForm : FormGroup;
  isSubmitting : boolean;
  errorMessage: string;
  public imgUrl;
  public isGoldwinWarehouse: Boolean = false;
  constructor(
    private fb: FormBuilder, 
    public authService: AuthService,
    private dialogService: DialogService,
    private route: ActivatedRoute, 
    private router: Router
  ){ }

  ngOnInit() {
    this.forgotPasswordForm = this.fb.group({
      email: [null, [Validators.required, Validators.pattern(PATTERN_EMAIL)]]
    });
    this.route.queryParams.subscribe(params => {
      if(params['email']){
        this.forgotPasswordForm.controls['email'].setValue(_.toLower(params['email']));
      }
    });

    this.isGoldwinWarehouse = (_.includes(window.location.hostname,'goldwin') ? true : false)

    this.imgUrl = (this.isGoldwinWarehouse ? 'assets/images/goldwin-logo.png' : 'assets/images/boc-logo.png');
  }

  onSubmit(value: any){
    this.isSubmitting = true;
    this.errorMessage = null;
    let email = _.toLower(_.trim(value['email']));

    let cognitoUser = new CognitoUser({
      Username: email,
      Pool: this.authService.userPool
    });

    cognitoUser.forgotPassword({
      onSuccess: (data) => {
        this.isSubmitting = false;
        this.router.navigateByUrl("/reset-password?email=" + email);
      },
      onFailure: (err) => {
        this.isSubmitting = false;
        if(!environment.production) {
          console.log(err);
        }
        if(err.name === COGNITO_ERROR_USER_NOT_FOUND_EXCEPTION){
          return this.forgotPasswordForm.controls['email'].setErrors({
            "notExisting": true
          });
        }
        this.errorMessage = err.message;
      }
    });

    // this.cognitoService.forgotPassword(_.toLower(value['email']), function(err, result){
    //   self.isSubmitting = false;
    //   if(err){
    //     if(err.name === COGNITO_ERROR_USER_NOT_FOUND_EXCEPTION){
    //       return self.forgotPasswordForm.controls['email'].setErrors({
    //         "notExisting": true
    //       });
    //     }
    //     return self.dialogService.confirm({
    //       title: "Forgot Password Failed", 
    //       message: err.message,
    //       button: "Close",
    //       hasCancel: false
    //     });
    //   }

    //   self.dialogService.confirm({
    //     title: "Verification Code Sent", 
    //     message: "Please check your email for verification code",
    //     button: "Close",
    //     hasCancel: false
    //   }).subscribe(res => {
    //     self.router.navigateByUrl("/reset-password?email=" + value['email']);
    //   });
    // });
  }

}
